import { SET_ERROR_LIST } from '../constants/constant';

export const setErrorList = (data) => ({
    type: SET_ERROR_LIST,
    payload: data
});
